module.exports = __webpack_public_path__ + "media/images/home/ic_events-da1ea327426d7fdfb40f9b6c495ec1a3.svg";